import { useEffect } from 'react';
import styles from './index.module.scss';
import Arrow from '../Arrow/Arrow';
import { Display } from '@/components/Display/Display';
import SimulationImg from '../../../components/SimulationImg';
const FactorItem = (props) => {
    const { curSection = {}, sections = [], setPreSection, preSection, handleChangeCurSection, isFading, goRoleIntroduce } = props;

    const onclickArrow = () => {
        const curIndex = sections.findIndex((item) => item.section_id === curSection.section_id);
        if (curIndex === sections.length - 1) {
            goRoleIntroduce();
            return;
        }
        handleChangeCurSection(sections[curIndex + 1]);
    };
    const handlePreData = () => {
        const curIndex = sections.findIndex((item) => item.section_id === curSection.section_id);
        if (curIndex > 0) {
            setPreSection(sections[curIndex - 1]);
        } else {
            setPreSection({});
        }
    };
    useEffect(() => {
        handlePreData();
    }, [curSection]);
    return (
        <div className={styles.container}>
            {/* 文本描述 */}
            <div className={styles.textDescription}>{curSection.content}</div>

            {/* 主图片区域 */}
            <div className={styles.imageContainer}>
                <Display show={!isFading && preSection?.image}>
                    <SimulationImg key={'pre' + preSection?.image} src={preSection?.image} alt="" className={`${styles.preImage}`} />
                </Display>

                <SimulationImg
                    key={curSection?.image}
                    src={curSection?.image}
                    alt=""
                    className={`${styles.mainImage} ${isFading ? styles.fadeOut : styles.fadeIn}`}
                />

                {/* 箭头图标 */}
                <div onClick={onclickArrow} className={styles.arrowContainer}>
                    <Arrow></Arrow>
                </div>
            </div>
        </div>
    );
};

export default FactorItem;
